import { Grid, IconButton } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import ClearIcon from "@material-ui/icons/Clear";
import RemoveIcon from "@material-ui/icons/Remove";
import {
	LicenceInfoObject,
	ProductBasketObject,
} from "../../pages/sale/SalePage";
import RxPaper from "../RxPaper";
import RxSelectBox from "../RxSelectBox";
import RxTypography from "../RxTypography";
import styles from "./RxShoppingCartItem.module.css";

interface RxShoppingCartItemProps {
	item: ProductBasketObject;
	licences?: LicenceInfoObject[];
	refreshShoppingCart: (value: boolean) => void;
	removeFromShoppingCart: (productBasketId: number) => void;
	updateBasketProduct: (
		productBasketId: number,
		quantity: number,
		licence: string | null
	) => void;
}

const RxShoppingCartItem = (props: RxShoppingCartItemProps) => {
	const hasDiscount = (): boolean => {
		return props.item.productBasketDiscount > 0;
	};

	return (
		<RxPaper className={styles.cartItem} elevation={1}>
			<Grid
				container
				spacing={1}
				direction="row"
				justifyContent="center"
				alignItems="center"
				alignContent="center"
			>
				<Grid item xs={11} sm={11}>
					<Grid container spacing={1}>
						<Grid item xs={8} sm={8}>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTypography
										variant={"body1"}
										align="left"
										label={props.item.productName}
										className={styles.boldFont}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									{props.item.productCategoryType !== "EYS" && (
										<RxSelectBox
											required
											fullwidth
											label="Lisans Seçimi"
											placeholder="Lisans Seçiniz"
											size="small"
											value={
												props.item.productLicence ?? "Yeni Lisans"
											}
											onChange={(event) => {
												props.updateBasketProduct(
													props.item.productBasketId,
													props.item.quantity,
													event.target.value === "Yeni Lisans"
														? null
														: (event.target.value as string)
												);
											}}
											items={
												props.item.parentProductSelectable
													? props.licences?.map((item) => ({
															label: item.serialNumber,
															value: item.serialNumber,
													  }))
													: [
															{
																label: "Yeni Lisans",
																value: "Yeni Lisans",
															},
													  ]
											}
										/>
									)}
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={4} sm={4}>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTypography
										variant={"body1"}
										align="right"
										label={
											props.item.productBasketPrice.toFixed(2) +
											" TL"
										}
										style={
											hasDiscount()
												? { textDecoration: "line-through" }
												: { fontWeight: "bold" }
										}
									/>
									{hasDiscount() && (
										<RxTypography
											variant={"body1"}
											align="right"
											label={
												props.item.productBasketTotalPrice.toFixed(
													2
												) + " TL"
											}
											style={
												hasDiscount()
													? { fontWeight: "bold" }
													: undefined
											}
										/>
									)}
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid
									item
									xs={12}
									sm={12}
									style={
										hasDiscount()
											? {
													display: "inline-flex",
													justifyContent: "end",
											  }
											: {
													display: "inline-flex",
													justifyContent: "end",
													marginTop: "20px",
											  }
									}
								>
									<IconButton
										aria-label="delete"
										size="small"
										onClick={() => {
											if (
												props.item.quantity >
												props.item.minNumberOfProduct
											) {
												props.updateBasketProduct(
													props.item.productBasketId,
													props.item.quantity - 1,
													props.item.productLicence
												);
											}
										}}
									>
										<RemoveIcon
											fontSize="inherit"
											className={styles.iButton}
										/>
									</IconButton>
									<RxTypography
										variant={"body1"}
										align="left"
										label={props.item.quantity}
									/>
									<IconButton
										aria-label="delete"
										size="small"
										onClick={() => {
											if (
												props.item.quantity <
												props.item.maxNumberOfProduct
											) {
												props.updateBasketProduct(
													props.item.productBasketId,
													props.item.quantity + 1,
													props.item.productLicence
												);
											}
										}}
									>
										<AddIcon
											fontSize="inherit"
											className={styles.iButton}
										/>
									</IconButton>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={1} sm={1}>
					<IconButton
						aria-label="delete"
						size="small"
						onClick={() => {
							props.removeFromShoppingCart(props.item.productBasketId);
						}}
						className={styles.marginLeft}
					>
						<ClearIcon fontSize="inherit" color="error" />
					</IconButton>
				</Grid>
			</Grid>
		</RxPaper>
	);
};

export default RxShoppingCartItem;
